import { grommet } from 'grommet/themes'
import { deepMerge } from 'grommet/utils'
import { css } from 'styled-components'

export const workingTheme = deepMerge(grommet, {
  global: {
    colors: {
      selected: '#f17900',
      border: 'gray',
    },
    focus: {
      border: {
        color: '#f17900',
      },
    },
  },
  select: {
    container: {
      extend: css`
        width: 245px;

        [role='option'] {
          div {
            span {
              white-space: pre-wrap;
            }
          }
        }
      `,
    },
    icons: {
      color: '#f17900',
    },
    text: {
      size: 'small',
    },
    step: 200,
    options: {
      text: {
        size: 'small',
      },
      container: {
        pad: 'small',
        border: {
          color: 'lightgrey',
          size: '1px',
          style: 'solid',
        },
      },
    },
  },
})
